var map = {
	"./Albion/Belt/Belt": [
		5270,
		5270
	],
	"./Albion/Belt/Belt.json": [
		5270,
		5270
	],
	"./Albion/Bracer/Bracer": [
		3650,
		3650
	],
	"./Albion/Bracer/Bracer.json": [
		3650,
		3650
	],
	"./Albion/Chain/Arms": [
		4258,
		4258
	],
	"./Albion/Chain/Arms.json": [
		4258,
		4258
	],
	"./Albion/Chain/Feet": [
		9949,
		9949
	],
	"./Albion/Chain/Feet.json": [
		9949,
		9949
	],
	"./Albion/Chain/Hands": [
		1561,
		1561
	],
	"./Albion/Chain/Hands.json": [
		1561,
		1561
	],
	"./Albion/Chain/Helm": [
		57,
		57
	],
	"./Albion/Chain/Helm.json": [
		57,
		57
	],
	"./Albion/Chain/Legs": [
		8032,
		8032
	],
	"./Albion/Chain/Legs.json": [
		8032,
		8032
	],
	"./Albion/Chain/Torso": [
		4936,
		4936
	],
	"./Albion/Chain/Torso.json": [
		4936,
		4936
	],
	"./Albion/Cloak/Cloak": [
		8482,
		8482
	],
	"./Albion/Cloak/Cloak.json": [
		8482,
		8482
	],
	"./Albion/Cloth/Arms": [
		633,
		633
	],
	"./Albion/Cloth/Arms.json": [
		633,
		633
	],
	"./Albion/Cloth/Feet": [
		1166,
		1166
	],
	"./Albion/Cloth/Feet.json": [
		1166,
		1166
	],
	"./Albion/Cloth/Hands": [
		860,
		860
	],
	"./Albion/Cloth/Hands.json": [
		860,
		860
	],
	"./Albion/Cloth/Helm": [
		7330,
		7330
	],
	"./Albion/Cloth/Helm.json": [
		7330,
		7330
	],
	"./Albion/Cloth/Legs": [
		5703,
		5703
	],
	"./Albion/Cloth/Legs.json": [
		5703,
		5703
	],
	"./Albion/Cloth/Torso": [
		6437,
		6437
	],
	"./Albion/Cloth/Torso.json": [
		6437,
		6437
	],
	"./Albion/Jewel/Jewel": [
		8310,
		8310
	],
	"./Albion/Jewel/Jewel.json": [
		8310,
		8310
	],
	"./Albion/Leather/Arms": [
		8782,
		8782
	],
	"./Albion/Leather/Arms.json": [
		8782,
		8782
	],
	"./Albion/Leather/Feet": [
		7057,
		7057
	],
	"./Albion/Leather/Feet.json": [
		7057,
		7057
	],
	"./Albion/Leather/Hands": [
		4677,
		4677
	],
	"./Albion/Leather/Hands.json": [
		4677,
		4677
	],
	"./Albion/Leather/Helm": [
		6917,
		6917
	],
	"./Albion/Leather/Helm.json": [
		6917,
		6917
	],
	"./Albion/Leather/Legs": [
		2012,
		2012
	],
	"./Albion/Leather/Legs.json": [
		2012,
		2012
	],
	"./Albion/Leather/Torso": [
		9260,
		9260
	],
	"./Albion/Leather/Torso.json": [
		9260,
		9260
	],
	"./Albion/Mythirian/Mythirian": [
		4958,
		4958
	],
	"./Albion/Mythirian/Mythirian.json": [
		4958,
		4958
	],
	"./Albion/Necklace/Necklace": [
		620,
		620
	],
	"./Albion/Necklace/Necklace.json": [
		620,
		620
	],
	"./Albion/Plate/Arms": [
		1281,
		1281
	],
	"./Albion/Plate/Arms.json": [
		1281,
		1281
	],
	"./Albion/Plate/Feet": [
		2182,
		2182
	],
	"./Albion/Plate/Feet.json": [
		2182,
		2182
	],
	"./Albion/Plate/Hands": [
		3876,
		3876
	],
	"./Albion/Plate/Hands.json": [
		3876,
		3876
	],
	"./Albion/Plate/Helm": [
		9578,
		9578
	],
	"./Albion/Plate/Helm.json": [
		9578,
		9578
	],
	"./Albion/Plate/Legs": [
		2159,
		2159
	],
	"./Albion/Plate/Legs.json": [
		2159,
		2159
	],
	"./Albion/Plate/Torso": [
		1757,
		1757
	],
	"./Albion/Plate/Torso.json": [
		1757,
		1757
	],
	"./Albion/Ring/Ring": [
		8920,
		8920
	],
	"./Albion/Ring/Ring.json": [
		8920,
		8920
	],
	"./Albion/Studded/Arms": [
		4776,
		4776
	],
	"./Albion/Studded/Arms.json": [
		4776,
		4776
	],
	"./Albion/Studded/Feet": [
		4759,
		4759
	],
	"./Albion/Studded/Feet.json": [
		4759,
		4759
	],
	"./Albion/Studded/Hands": [
		6003,
		6003
	],
	"./Albion/Studded/Hands.json": [
		6003,
		6003
	],
	"./Albion/Studded/Helm": [
		3463,
		3463
	],
	"./Albion/Studded/Helm.json": [
		3463,
		3463
	],
	"./Albion/Studded/Legs": [
		38,
		38
	],
	"./Albion/Studded/Legs.json": [
		38,
		38
	],
	"./Albion/Studded/Torso": [
		3770,
		3770
	],
	"./Albion/Studded/Torso.json": [
		3770,
		3770
	],
	"./Albion/Weapons/Bow/Thrust": [
		734,
		734
	],
	"./Albion/Weapons/Bow/Thrust.json": [
		734,
		734
	],
	"./Albion/Weapons/Crossbow/Siege": [
		8493,
		8493
	],
	"./Albion/Weapons/Crossbow/Siege.json": [
		8493,
		8493
	],
	"./Albion/Weapons/Crossbow/Slash": [
		6763,
		6763
	],
	"./Albion/Weapons/Crossbow/Slash.json": [
		6763,
		6763
	],
	"./Albion/Weapons/Crossbow/Thrust": [
		7968,
		7968
	],
	"./Albion/Weapons/Crossbow/Thrust.json": [
		7968,
		7968
	],
	"./Albion/Weapons/Crush/Crush": [
		3732,
		3732
	],
	"./Albion/Weapons/Crush/Crush.json": [
		3732,
		3732
	],
	"./Albion/Weapons/Fist Wraps/Crush": [
		6950,
		6950
	],
	"./Albion/Weapons/Fist Wraps/Crush.json": [
		6950,
		6950
	],
	"./Albion/Weapons/Flexible/Crush": [
		3594,
		3594
	],
	"./Albion/Weapons/Flexible/Crush.json": [
		3594,
		3594
	],
	"./Albion/Weapons/Flexible/Elemental": [
		4916,
		4916
	],
	"./Albion/Weapons/Flexible/Elemental.json": [
		4916,
		4916
	],
	"./Albion/Weapons/Flexible/Slash": [
		1136,
		1136
	],
	"./Albion/Weapons/Flexible/Slash.json": [
		1136,
		1136
	],
	"./Albion/Weapons/Flexible/Spirit": [
		2358,
		2358
	],
	"./Albion/Weapons/Flexible/Spirit.json": [
		2358,
		2358
	],
	"./Albion/Weapons/Flexible/Thrust": [
		2369,
		2369
	],
	"./Albion/Weapons/Flexible/Thrust.json": [
		2369,
		2369
	],
	"./Albion/Weapons/Instrument/Instrument": [
		9308,
		9308
	],
	"./Albion/Weapons/Instrument/Instrument.json": [
		9308,
		9308
	],
	"./Albion/Weapons/Longbow/Thrust": [
		632,
		632
	],
	"./Albion/Weapons/Longbow/Thrust.json": [
		632,
		632
	],
	"./Albion/Weapons/Mauler Staff/Crush": [
		8015,
		8015
	],
	"./Albion/Weapons/Mauler Staff/Crush.json": [
		8015,
		8015
	],
	"./Albion/Weapons/Painworking/Elemental": [
		7378,
		7378
	],
	"./Albion/Weapons/Painworking/Elemental.json": [
		7378,
		7378
	],
	"./Albion/Weapons/Polearm/Crush": [
		7671,
		7671
	],
	"./Albion/Weapons/Polearm/Crush.json": [
		7671,
		7671
	],
	"./Albion/Weapons/Polearm/Slash": [
		1229,
		1229
	],
	"./Albion/Weapons/Polearm/Slash.json": [
		1229,
		1229
	],
	"./Albion/Weapons/Polearm/Thrust": [
		1526,
		1526
	],
	"./Albion/Weapons/Polearm/Thrust.json": [
		1526,
		1526
	],
	"./Albion/Weapons/Shield/Large": [
		9256,
		9256
	],
	"./Albion/Weapons/Shield/Large.json": [
		9256,
		9256
	],
	"./Albion/Weapons/Shield/Medium": [
		6430,
		6430
	],
	"./Albion/Weapons/Shield/Medium.json": [
		6430,
		6430
	],
	"./Albion/Weapons/Shield/Small": [
		9648,
		9648
	],
	"./Albion/Weapons/Shield/Small.json": [
		9648,
		9648
	],
	"./Albion/Weapons/Slash/Slash": [
		6596,
		6596
	],
	"./Albion/Weapons/Slash/Slash.json": [
		6596,
		6596
	],
	"./Albion/Weapons/Staff/Crush": [
		2513,
		2513
	],
	"./Albion/Weapons/Staff/Crush.json": [
		2513,
		2513
	],
	"./Albion/Weapons/Staff/Elemental": [
		619,
		619
	],
	"./Albion/Weapons/Staff/Elemental.json": [
		619,
		619
	],
	"./Albion/Weapons/Thrust/Thrust": [
		2150,
		2150
	],
	"./Albion/Weapons/Thrust/Thrust.json": [
		2150,
		2150
	],
	"./Albion/Weapons/Two Handed/Crush": [
		471,
		471
	],
	"./Albion/Weapons/Two Handed/Crush.json": [
		471,
		471
	],
	"./Albion/Weapons/Two Handed/Elemental": [
		4233,
		4233
	],
	"./Albion/Weapons/Two Handed/Elemental.json": [
		4233,
		4233
	],
	"./Albion/Weapons/Two Handed/Slash": [
		7549,
		7549
	],
	"./Albion/Weapons/Two Handed/Slash.json": [
		7549,
		7549
	],
	"./Albion/Weapons/Two Handed/Thrust": [
		9302,
		9302
	],
	"./Albion/Weapons/Two Handed/Thrust.json": [
		9302,
		9302
	],
	"./Albion_items": [
		4685,
		4685
	],
	"./Albion_items.json": [
		4685,
		4685
	],
	"./Hibernia/Belt/Belt": [
		4047,
		4047
	],
	"./Hibernia/Belt/Belt.json": [
		4047,
		4047
	],
	"./Hibernia/Bracer/Bracer": [
		8143,
		8143
	],
	"./Hibernia/Bracer/Bracer.json": [
		8143,
		8143
	],
	"./Hibernia/Chain/Arms": [
		273,
		273
	],
	"./Hibernia/Chain/Arms.json": [
		273,
		273
	],
	"./Hibernia/Chain/Feet": [
		4822,
		4822
	],
	"./Hibernia/Chain/Feet.json": [
		4822,
		4822
	],
	"./Hibernia/Chain/Hands": [
		4324,
		4324
	],
	"./Hibernia/Chain/Hands.json": [
		4324,
		4324
	],
	"./Hibernia/Chain/Helm": [
		2218,
		2218
	],
	"./Hibernia/Chain/Helm.json": [
		2218,
		2218
	],
	"./Hibernia/Chain/Legs": [
		4799,
		4799
	],
	"./Hibernia/Chain/Legs.json": [
		4799,
		4799
	],
	"./Hibernia/Chain/Torso": [
		2205,
		2205
	],
	"./Hibernia/Chain/Torso.json": [
		2205,
		2205
	],
	"./Hibernia/Cloak/Cloak": [
		6987,
		6987
	],
	"./Hibernia/Cloak/Cloak.json": [
		6987,
		6987
	],
	"./Hibernia/Cloth/Arms": [
		3674,
		3674
	],
	"./Hibernia/Cloth/Arms.json": [
		3674,
		3674
	],
	"./Hibernia/Cloth/Feet": [
		8837,
		8837
	],
	"./Hibernia/Cloth/Feet.json": [
		8837,
		8837
	],
	"./Hibernia/Cloth/Hands": [
		9201,
		9201
	],
	"./Hibernia/Cloth/Hands.json": [
		9201,
		9201
	],
	"./Hibernia/Cloth/Helm": [
		577,
		577
	],
	"./Hibernia/Cloth/Helm.json": [
		577,
		577
	],
	"./Hibernia/Cloth/Legs": [
		2744,
		2744
	],
	"./Hibernia/Cloth/Legs.json": [
		2744,
		2744
	],
	"./Hibernia/Cloth/Torso": [
		3616,
		3616
	],
	"./Hibernia/Cloth/Torso.json": [
		3616,
		3616
	],
	"./Hibernia/Jewel/Jewel": [
		4943,
		4943
	],
	"./Hibernia/Jewel/Jewel.json": [
		4943,
		4943
	],
	"./Hibernia/Leather/Arms": [
		1821,
		1821
	],
	"./Hibernia/Leather/Arms.json": [
		1821,
		1821
	],
	"./Hibernia/Leather/Feet": [
		810,
		810
	],
	"./Hibernia/Leather/Feet.json": [
		810,
		810
	],
	"./Hibernia/Leather/Hands": [
		4304,
		4304
	],
	"./Hibernia/Leather/Hands.json": [
		4304,
		4304
	],
	"./Hibernia/Leather/Helm": [
		70,
		70
	],
	"./Hibernia/Leather/Helm.json": [
		70,
		70
	],
	"./Hibernia/Leather/Legs": [
		8379,
		8379
	],
	"./Hibernia/Leather/Legs.json": [
		8379,
		8379
	],
	"./Hibernia/Leather/Torso": [
		1569,
		1569
	],
	"./Hibernia/Leather/Torso.json": [
		1569,
		1569
	],
	"./Hibernia/Mythirian/Mythirian": [
		5895,
		5895
	],
	"./Hibernia/Mythirian/Mythirian.json": [
		5895,
		5895
	],
	"./Hibernia/Necklace/Necklace": [
		3133,
		3133
	],
	"./Hibernia/Necklace/Necklace.json": [
		3133,
		3133
	],
	"./Hibernia/Ring/Ring": [
		5405,
		5405
	],
	"./Hibernia/Ring/Ring.json": [
		5405,
		5405
	],
	"./Hibernia/Studded/Arms": [
		1467,
		1467
	],
	"./Hibernia/Studded/Arms.json": [
		1467,
		1467
	],
	"./Hibernia/Studded/Feet": [
		4636,
		4636
	],
	"./Hibernia/Studded/Feet.json": [
		4636,
		4636
	],
	"./Hibernia/Studded/Hands": [
		9954,
		9954
	],
	"./Hibernia/Studded/Hands.json": [
		9954,
		9954
	],
	"./Hibernia/Studded/Helm": [
		6604,
		6604
	],
	"./Hibernia/Studded/Helm.json": [
		6604,
		6604
	],
	"./Hibernia/Studded/Legs": [
		1353,
		1353
	],
	"./Hibernia/Studded/Legs.json": [
		1353,
		1353
	],
	"./Hibernia/Studded/Torso": [
		2563,
		2563
	],
	"./Hibernia/Studded/Torso.json": [
		2563,
		2563
	],
	"./Hibernia/Weapons/Blades/Slash": [
		5647,
		5647
	],
	"./Hibernia/Weapons/Blades/Slash.json": [
		5647,
		5647
	],
	"./Hibernia/Weapons/Blunt/Crush": [
		8585,
		8585
	],
	"./Hibernia/Weapons/Blunt/Crush.json": [
		8585,
		8585
	],
	"./Hibernia/Weapons/Bow/Thrust": [
		4369,
		4369
	],
	"./Hibernia/Weapons/Bow/Thrust.json": [
		4369,
		4369
	],
	"./Hibernia/Weapons/Celtic Spear/Slash": [
		7665,
		7665
	],
	"./Hibernia/Weapons/Celtic Spear/Slash.json": [
		7665,
		7665
	],
	"./Hibernia/Weapons/Celtic Spear/Thrust": [
		4885,
		7266
	],
	"./Hibernia/Weapons/Celtic Spear/Thrust.json": [
		4885,
		7266
	],
	"./Hibernia/Weapons/Fist Wraps/Crush": [
		4061,
		4061
	],
	"./Hibernia/Weapons/Fist Wraps/Crush.json": [
		4061,
		4061
	],
	"./Hibernia/Weapons/Instrument/Instrument": [
		1429,
		1429
	],
	"./Hibernia/Weapons/Instrument/Instrument.json": [
		1429,
		1429
	],
	"./Hibernia/Weapons/Large Weaponry/Crush": [
		1494,
		1494
	],
	"./Hibernia/Weapons/Large Weaponry/Crush.json": [
		1494,
		1494
	],
	"./Hibernia/Weapons/Large Weaponry/Slash": [
		2540,
		2540
	],
	"./Hibernia/Weapons/Large Weaponry/Slash.json": [
		2540,
		2540
	],
	"./Hibernia/Weapons/Large Weaponry/Thrust": [
		7349,
		7349
	],
	"./Hibernia/Weapons/Large Weaponry/Thrust.json": [
		7349,
		7349
	],
	"./Hibernia/Weapons/Mauler Staff/Crush": [
		4968,
		4968
	],
	"./Hibernia/Weapons/Mauler Staff/Crush.json": [
		4968,
		4968
	],
	"./Hibernia/Weapons/Piercing/Elemental": [
		3515,
		3515
	],
	"./Hibernia/Weapons/Piercing/Elemental.json": [
		3515,
		3515
	],
	"./Hibernia/Weapons/Piercing/Thrust": [
		432,
		432
	],
	"./Hibernia/Weapons/Piercing/Thrust.json": [
		432,
		432
	],
	"./Hibernia/Weapons/Recurve Bow/Thrust": [
		7753,
		7753
	],
	"./Hibernia/Weapons/Recurve Bow/Thrust.json": [
		7753,
		7753
	],
	"./Hibernia/Weapons/Scythe/Elemental": [
		6516,
		6516
	],
	"./Hibernia/Weapons/Scythe/Elemental.json": [
		6516,
		6516
	],
	"./Hibernia/Weapons/Scythe/Slash": [
		7392,
		7392
	],
	"./Hibernia/Weapons/Scythe/Slash.json": [
		7392,
		7392
	],
	"./Hibernia/Weapons/Scythe/Thrust": [
		3649,
		3649
	],
	"./Hibernia/Weapons/Scythe/Thrust.json": [
		3649,
		3649
	],
	"./Hibernia/Weapons/Shield/Large": [
		6011,
		6011
	],
	"./Hibernia/Weapons/Shield/Large.json": [
		6011,
		6011
	],
	"./Hibernia/Weapons/Shield/Medium": [
		1259,
		1259
	],
	"./Hibernia/Weapons/Shield/Medium.json": [
		1259,
		1259
	],
	"./Hibernia/Weapons/Shield/Small": [
		3251,
		3251
	],
	"./Hibernia/Weapons/Shield/Small.json": [
		3251,
		3251
	],
	"./Hibernia/Weapons/Staff/Crush": [
		9744,
		9744
	],
	"./Hibernia/Weapons/Staff/Crush.json": [
		9744,
		9744
	],
	"./Hibernia/Weapons/Staff/Elemental": [
		9746,
		9746
	],
	"./Hibernia/Weapons/Staff/Elemental.json": [
		9746,
		9746
	],
	"./Hibernia/Weapons/Staff/Thrust": [
		5607,
		5607
	],
	"./Hibernia/Weapons/Staff/Thrust.json": [
		5607,
		5607
	],
	"./Hibernia_items": [
		9876,
		9876
	],
	"./Hibernia_items.json": [
		9876,
		9876
	],
	"./Midgard/Belt/Belt": [
		33,
		33
	],
	"./Midgard/Belt/Belt.json": [
		33,
		33
	],
	"./Midgard/Bracer/Bracer": [
		8097,
		8097
	],
	"./Midgard/Bracer/Bracer.json": [
		8097,
		8097
	],
	"./Midgard/Chain/Arms": [
		7055,
		7055
	],
	"./Midgard/Chain/Arms.json": [
		7055,
		7055
	],
	"./Midgard/Chain/Feet": [
		2968,
		2968
	],
	"./Midgard/Chain/Feet.json": [
		2968,
		2968
	],
	"./Midgard/Chain/Hands": [
		8502,
		8502
	],
	"./Midgard/Chain/Hands.json": [
		8502,
		8502
	],
	"./Midgard/Chain/Helm": [
		5712,
		5712
	],
	"./Midgard/Chain/Helm.json": [
		5712,
		5712
	],
	"./Midgard/Chain/Legs": [
		8221,
		8221
	],
	"./Midgard/Chain/Legs.json": [
		8221,
		8221
	],
	"./Midgard/Chain/Torso": [
		4895,
		4895
	],
	"./Midgard/Chain/Torso.json": [
		4895,
		4895
	],
	"./Midgard/Cloak/Cloak": [
		4341,
		4341
	],
	"./Midgard/Cloak/Cloak.json": [
		4341,
		4341
	],
	"./Midgard/Cloth/Arms": [
		7760,
		7760
	],
	"./Midgard/Cloth/Arms.json": [
		7760,
		7760
	],
	"./Midgard/Cloth/Feet": [
		1567,
		1567
	],
	"./Midgard/Cloth/Feet.json": [
		1567,
		1567
	],
	"./Midgard/Cloth/Hands": [
		3611,
		3611
	],
	"./Midgard/Cloth/Hands.json": [
		3611,
		3611
	],
	"./Midgard/Cloth/Helm": [
		6111,
		6111
	],
	"./Midgard/Cloth/Helm.json": [
		6111,
		6111
	],
	"./Midgard/Cloth/Legs": [
		350,
		350
	],
	"./Midgard/Cloth/Legs.json": [
		350,
		350
	],
	"./Midgard/Cloth/Torso": [
		498,
		498
	],
	"./Midgard/Cloth/Torso.json": [
		498,
		498
	],
	"./Midgard/Jewel/Jewel": [
		6817,
		6817
	],
	"./Midgard/Jewel/Jewel.json": [
		6817,
		6817
	],
	"./Midgard/Leather/Arms": [
		4540,
		4540
	],
	"./Midgard/Leather/Arms.json": [
		4540,
		4540
	],
	"./Midgard/Leather/Feet": [
		9224,
		9224
	],
	"./Midgard/Leather/Feet.json": [
		9224,
		9224
	],
	"./Midgard/Leather/Hands": [
		454,
		454
	],
	"./Midgard/Leather/Hands.json": [
		454,
		454
	],
	"./Midgard/Leather/Helm": [
		6912,
		6912
	],
	"./Midgard/Leather/Helm.json": [
		6912,
		6912
	],
	"./Midgard/Leather/Legs": [
		1197,
		1197
	],
	"./Midgard/Leather/Legs.json": [
		1197,
		1197
	],
	"./Midgard/Leather/Torso": [
		2223,
		2223
	],
	"./Midgard/Leather/Torso.json": [
		2223,
		2223
	],
	"./Midgard/Mythirian/Mythirian": [
		7921,
		7921
	],
	"./Midgard/Mythirian/Mythirian.json": [
		7921,
		7921
	],
	"./Midgard/Necklace/Necklace": [
		6391,
		6391
	],
	"./Midgard/Necklace/Necklace.json": [
		6391,
		6391
	],
	"./Midgard/Ring/Ring": [
		2767,
		2767
	],
	"./Midgard/Ring/Ring.json": [
		2767,
		2767
	],
	"./Midgard/Studded/Arms": [
		3685,
		3685
	],
	"./Midgard/Studded/Arms.json": [
		3685,
		3685
	],
	"./Midgard/Studded/Feet": [
		786,
		786
	],
	"./Midgard/Studded/Feet.json": [
		786,
		786
	],
	"./Midgard/Studded/Hands": [
		5032,
		5032
	],
	"./Midgard/Studded/Hands.json": [
		5032,
		5032
	],
	"./Midgard/Studded/Helm": [
		5102,
		5102
	],
	"./Midgard/Studded/Helm.json": [
		5102,
		5102
	],
	"./Midgard/Studded/Legs": [
		9619,
		9619
	],
	"./Midgard/Studded/Legs.json": [
		9619,
		9619
	],
	"./Midgard/Studded/Torso": [
		6697,
		6697
	],
	"./Midgard/Studded/Torso.json": [
		6697,
		6697
	],
	"./Midgard/Weapons/Axe/Crush": [
		7640,
		7640
	],
	"./Midgard/Weapons/Axe/Crush.json": [
		7640,
		7640
	],
	"./Midgard/Weapons/Axe/Slash": [
		170,
		170
	],
	"./Midgard/Weapons/Axe/Slash.json": [
		170,
		170
	],
	"./Midgard/Weapons/Composite Bow/Thrust": [
		9982,
		9982
	],
	"./Midgard/Weapons/Composite Bow/Thrust.json": [
		9982,
		9982
	],
	"./Midgard/Weapons/Fist Wraps/Crush": [
		8463,
		8463
	],
	"./Midgard/Weapons/Fist Wraps/Crush.json": [
		8463,
		8463
	],
	"./Midgard/Weapons/Hammer/Crush": [
		30,
		30
	],
	"./Midgard/Weapons/Hammer/Crush.json": [
		30,
		30
	],
	"./Midgard/Weapons/Hand to Hand/Slash": [
		1709,
		1709
	],
	"./Midgard/Weapons/Hand to Hand/Slash.json": [
		1709,
		1709
	],
	"./Midgard/Weapons/Hand to Hand/Thrust": [
		2118,
		2118
	],
	"./Midgard/Weapons/Hand to Hand/Thrust.json": [
		2118,
		2118
	],
	"./Midgard/Weapons/Mauler Staff/Crush": [
		838,
		838
	],
	"./Midgard/Weapons/Mauler Staff/Crush.json": [
		838,
		838
	],
	"./Midgard/Weapons/Shield/Large": [
		3569,
		3569
	],
	"./Midgard/Weapons/Shield/Large.json": [
		3569,
		3569
	],
	"./Midgard/Weapons/Shield/Medium": [
		9381,
		9381
	],
	"./Midgard/Weapons/Shield/Medium.json": [
		9381,
		9381
	],
	"./Midgard/Weapons/Shield/Small": [
		9741,
		9741
	],
	"./Midgard/Weapons/Shield/Small.json": [
		9741,
		9741
	],
	"./Midgard/Weapons/Spear/Elemental": [
		9629,
		4391
	],
	"./Midgard/Weapons/Spear/Elemental.json": [
		9629,
		4391
	],
	"./Midgard/Weapons/Spear/Slash": [
		9919,
		9919
	],
	"./Midgard/Weapons/Spear/Slash.json": [
		9919,
		9919
	],
	"./Midgard/Weapons/Spear/Thrust": [
		4172,
		4172
	],
	"./Midgard/Weapons/Spear/Thrust.json": [
		4172,
		4172
	],
	"./Midgard/Weapons/Staff/Crush": [
		5366,
		5366
	],
	"./Midgard/Weapons/Staff/Crush.json": [
		5366,
		5366
	],
	"./Midgard/Weapons/Staff/Elemental": [
		408,
		408
	],
	"./Midgard/Weapons/Staff/Elemental.json": [
		408,
		408
	],
	"./Midgard/Weapons/Sword/Slash": [
		7183,
		7183
	],
	"./Midgard/Weapons/Sword/Slash.json": [
		7183,
		7183
	],
	"./Midgard/Weapons/Thrown/Crush": [
		2146,
		2146
	],
	"./Midgard/Weapons/Thrown/Crush.json": [
		2146,
		2146
	],
	"./Midgard/Weapons/Thrown/Slash": [
		2792,
		2792
	],
	"./Midgard/Weapons/Thrown/Slash.json": [
		2792,
		2792
	],
	"./Midgard/Weapons/Thrown/Thrust": [
		4505,
		4505
	],
	"./Midgard/Weapons/Thrown/Thrust.json": [
		4505,
		4505
	],
	"./Midgard_items": [
		9502,
		9502
	],
	"./Midgard_items.json": [
		9502,
		9502
	],
	"./classArmorOptionsMap": [
		9204
	],
	"./classArmorOptionsMap.json": [
		9204
	],
	"./classSlotWeaponMap": [
		5501
	],
	"./classSlotWeaponMap.json": [
		5501
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2554;
module.exports = webpackAsyncContext;